import React, { useState } from 'react';
import { Form } from 'react-bootstrap'

function Time(props) {
    const [hours, setHours] = useState(null)
    const [min, setMin] = useState(null)

    const handleHour = (event) => {
        var hValue = event.target.value
        var mValue = min != null ? min : 0
        setMin(mValue)
        setHours(hValue)
        var time = hValue.toString().padStart(2, "0") + ":" + mValue.toString().padStart(2, "0")
        props.handleAnswerChange(time)
    }

    const handleMin = (event) => {
        setMin(event.target.value)
        if (hours != null && event.target.value != null) {
            var time = hours.toString().padStart(2, "0") + ":" + event.target.value.toString().padStart(2, "0")
            props.handleAnswerChange(time)
        }
    }
    if (props.user_answers !== null && hours == null && min == null) {
        const time = props.user_answers
        setMin(parseInt(time.split(":")[1]))
        setHours(parseInt(time.split(":")[0]))
    }

    return (
        <div className='alert-time'>
            <Form.Group className='question-times' controlId="formGroupHours">
                <Form.Label>{props.label !== "" ? props.label : "Hours:"}</Form.Label>
                <span className='drop-arrow'></span>
                <Form.Select aria-label="Default select example" value={hours} onChange={handleHour}>
                    {hours == null ? <option value={null}></option> : null}
                    {Array.from({ length: props.time + 1 }, (_, i) => (
                        <option key={i} value={i}>
                            {i.toString().padStart(2, "0")}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
            <span>:</span>
            <Form.Group className='question-times' controlId="formGroupMinutes">
                <Form.Label>{props.label === "" ? "Minutes:" : null}</Form.Label>
                <span className='drop-arrow'></span>
                <Form.Select aria-label="Default select example" value={min} onChange={handleMin}>
                    {min == null ? <option value={null}></option> : null}
                    <option value={"00"}> 00 </option>
                    <option value={"15"}> 15 </option>
                    <option value={"30"}> 30 </option>
                    <option value={"45"}> 45 </option>
                </Form.Select>
            </Form.Group>
        </div>
    )
}
export default Time;